'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SurflinePageContainer = require('./SurflinePageContainer');

var _SurflinePageContainer2 = _interopRequireDefault(_SurflinePageContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SurflinePageContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflinePageContainer/index.js
// module id = 674
// module chunks = 11